import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import styled from 'styled-components';

import LogoW from './LogoW';

import * as userActions from '../../actions/userActions';

import {
  px,
  colors,
  founders,
  roboto,
  trirong,
} from '../Common/style';

const config = window.weftConfig;


const ProTag = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.safetyLemon};
  padding: ${px(4)} ${px(6)};
  border-radius: ${px(4)};
  font-size: ${px(12)};
  font-weight: 600;
  margin-left: ${px(6)};
`;

const NameSpan = styled.span`
  display: inline-flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;

  & svg {
    height: ${px(10)};
    margin-right: ${px(2)};
  }
`;

class AccountDropdown extends Component {
  handleClickOutside(e) {
    if(this.props.accountDropdownVisible) {
      this.props.hideUserDropdown();
    }
  }

  componentDidMount() {
    if(this.props.isAuthenticated) {
      this.props.fetchUserData();
    }
  }

  render() {
    const authenticatedHeaderNav = () => (
      <div className={classnames({
        'dropdown': true,
        'is-right': true,
        'is-active': (this.props.accountDropdownVisible)
      })}>
        <div className={'dropdown-trigger'}>
          <button className={'button'} onClick={() => this.props.toggleUserDropdown()}>
            <NameSpan>
              {this.props.userFirstName ? `Hi, ${this.props.userFirstName}` : false}
                {this.props.hasPro && (
                  <ProTag><LogoW />PRO</ProTag>
                )}
              </NameSpan>
            <i className={'material-icons'}>{'arrow_drop_down'}</i>
          </button>
        </div>

        <div className={'dropdown-menu'}>
          <div className={'dropdown-content'}>
            <NavLink 
              to={'/account'} 
              className={'dropdown-item'}
              onClick={() => this.props.hideUserDropdown()}
            >
              {'MY ACCOUNT'}
            </NavLink>


            {config.privateRoutes ?
              <NavLink 
                to={'/sign-in'} 
                onClick={() => {this.props.hideUserDropdown(); this.props.logoutUser()}}
                className={'dropdown-item'}>
                {'SIGN OUT'}
              </NavLink>
            :
              <NavLink 
                to={'/'} 
                onClick={() => {this.props.hideUserDropdown(); this.props.logoutUser()}}
                className={'dropdown-item'}>
                {'SIGN OUT'}
              </NavLink>
            }
          </div>
        </div>
      </div>
      );
    
    const unAuthenticatedHeaderNav = () => (
      <div className={'dropdown is-right'}>
        <div className={'dropdown-trigger'}>
          <NavLink
            to={'/sign-in'}
            className={'button'}
          >
            <span>Sign In</span>
          </NavLink>
        </div>
      </div>
    );

    return (
      <div>
        {this.props.isAuthenticated ? 
          authenticatedHeaderNav()
        : 
          unAuthenticatedHeaderNav()
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isAuthenticated: state.user.isAuthenticated,
    userFirstName: state.user.first_name,
    hasPro: state.user.pro_subscription,
    accountDropdownVisible: state.user.accountDropdownVisible,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({...userActions}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(onClickOutside(AccountDropdown));
